import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { SlideDetailState } from "shared/reducers/slideDetailReducer";

import FlaggingModal from "./modals/FlaggingModal";

type FlaggingTool = {
  slideDetail: SlideDetailState;
  caseDetail: CaseDetailState;
};

const FlaggingTool = ({ caseDetail, slideDetail }: FlaggingTool) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsModalOpen(false);
  }, [slideDetail.id]);

  return (
    <>
      <button
        type="button"
        title="flag"
        className={isModalOpen ? "active" : undefined}
        onClick={() => {
          setIsModalOpen(true);
        }}
        data-tip=""
        data-for="button-flag"
      >
        <FontAwesomeIcon icon="flag" />
      </button>
      <ReactTooltip place="bottom" id="button-flag" type="info">
        Flag Slide
      </ReactTooltip>
      {isModalOpen && (
        <FlaggingModal
          caseDetail={caseDetail}
          slideDetail={slideDetail}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
        />
      )}
    </>
  );
};

export default FlaggingTool;
